/**
 * Selectable list of exchanges
 */
import { helpers } from '@kattana-io/common';

import checkmark from '../../../../assets/images/check.svg';

import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';

import gateio from '../../../../assets/images/exchanges/gateio.svg';
import binance from '../../../../assets/images/exchanges/binance.svg';
import hitbtc from '../../../../assets/images/exchanges/hitbtc.png';
import uniswap from '../../../../assets/images/exchanges/uniswap.svg';
import pancakeswap from '../../../../assets/images/exchanges/pancakeswap.svg';
import sushiswap from '../../../../assets/images/exchanges/sushiswap.svg';
import traderjoe from '../../../../assets/images/exchanges/traderjoe.png';
import pangolin from '../../../../assets/images/exchanges/pangolin.svg';
import quickswap from '../../../../assets/images/exchanges/quickswap.svg';
import mdex from '../../../../assets/images/exchanges/mdex.svg';
import impossibleswap from '../../../../assets/images/exchanges/impossibleswap.svg';
import maiar from '../../../../assets/images/exchanges/maiar.svg';
import spookyswap from '../../../../assets/images/exchanges/spookyswap.svg';
import huobi from '../../../../assets/images/exchanges/huobi.svg';
import sunswap from '../../../../assets/images/exchanges/sunswap.png';
import justmoney from '../../../../assets/images/exchanges/justmoney.svg';
import kucoin from '../../../../assets/images/exchanges/kucoin.svg';
import kyber from '../../../../assets/images/exchanges/kyber.svg';
import biswap from '../../../../assets/images/exchanges/biswap.svg';
import { connect } from 'react-redux';
import { IMobileFilterProps } from '../../../SearchTable/SearchTable';

const imageMapping = {
  binance,
  hitbtc,
  gateio,
  uniswap,
  pancakeswap,
  sushiswap,
  traderjoe,
  pangolin,
  quickswap,
  mdex,
  impossibleswap,
  maiar,
  spookyswap,
  huobi,
  sunswap,
  justmoney,
  kucoin,
  kyber,
  biswap
};

export interface ITickerFilterOptionsProps extends IMobileFilterProps {
  exchanges: string[];
}

const LIST = [...helpers.exchanges.CEX_LIST, ...helpers.exchanges.DEX_LIST];

const FilterOptions = (props: ITickerFilterOptionsProps) => {
  const { exchanges, setValue } = props;

  const onClick = (item: string) => {
    if (exchanges.includes(item)) {
      setValue(exchanges.filter((i) => i !== item));
    } else {
      setValue([...exchanges, item]);
    }
  };

  return (
    <>
      {LIST.map((item) => {
        const isActive = exchanges.includes(item);
        return (
          <div
            className={`exchange_option${
              isActive ? ' exchange_option--active' : ''
            }`}
            key={item}
            onClick={() => onClick(item)}
          >
            <div
              className={`exchange_option__title${
                isActive ? ' exchange_option__title--active' : ''
              }`}
            >
              {isActive && (
                <div className='exchange_option__title__checkmark'>
                  <Image size='m' src={checkmark} />
                </div>
              )}
              <Text
                size={14}
                className={`text--weight-500 ${
                  isActive ? 'text--grey-200' : 'text--grey-400'
                }`}
              >
                {item}
              </Text>
            </div>
            <div className='exchange_option__icon'>
              <Image src={(imageMapping as any)[item]} size='m' />
            </div>
          </div>
        );
      })}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  exchanges: state.modalSearch.exchanges,
});

export default connect(mapStateToProps, {})(FilterOptions);
